import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { withRouter } from "react-router-dom";
import KnowledgeService from "../../../../services/KnowledgeService";
import PageComponent from "../PageComponent";
import Bam from "./Bam";

class BamContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.state = {
      recommendedKnowledge: undefined
    };

    this.knowledgeService = new KnowledgeService(this.keycloak);
    this.changePath = this.changePath.bind(this);
  }

  componentDidMount() {
    this.loadRecommended();
  }

  loadRecommended = () => {
    const pageInfo = { size: 5 };
    this.prepareCall(
      this.knowledgeService.getRecommended(
        pageInfo,
        this.onLoadRecommended,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadRecommended = data => {
    this.setState({ recommendedKnowledge: data?._embedded?.content || [] });
  };

  render() {
    return (
      <Bam
        onClassificationClick={this.props.onClassificationClick}
        onTagClick={this.props.onTagClick}
        recommendedKnowledge={this.state.recommendedKnowledge}
        {...this.handlerProps()}
        changePath={this.changePath}
      />
    );
  }
}
export default withKeycloak(withRouter(BamContainer));
